<template lang="pug">
.tabs.regular-page-tabs
    .nav.nav-tabs.nav-tabs-justified(role="tablist")
        slot(name="tablistitems" v-bind:tabsMeta="tabsMeta" :toggleTab="toggleTab")
            regular-tab-nav-button(:key="'nav-tab-button-' + tabMeta.id" v-for="tabMeta in tabsMeta" :tab-meta="tabMeta" @tab-click="toggleTab(tabMeta.id)")

    .tab-content
        slot
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Provide, Watch,
} from 'vue-property-decorator';
import { TabsProvder } from '@/backoffice/legacy/mixins/design/tabs';
import RegularTabNavButton from '@/components/decorations/RegularTabNavButton.vue';

@Component({
  name: 'regular-tabs',
  components: { RegularTabNavButton },
})
export default class RegularTabs extends Vue {
    @Provide('tabsProvider')
    tabsProvider = new TabsProvder()

    // provide() {
    //     return {
    //         tabsProvider: this.tabsProvider
    //     }
    // }

    @Watch('tabActiveIndex')
    onTabActive() {
      this.$emit('tab-active', this.tabsProvider.active);
    }

    get tabActiveIndex() {
      return this.tabsProvider.active;
    }

    toggleTab(id: number): any {
      this.tabsProvider.toggleTab(id);
    }

    get tabsMeta() {
      return this.tabsProvider.tabsMeta;
    }
}
</script>

<style lang="less">
    @import '../../less-mixins/legacy-config';

    /*
    .tabs.regular-page-tabs {
        .nav-tabs {
            background: none;
            margin-bottom: 2em;
            border-bottom: 1px solid #b7b7c4;
            li {
                font-size: 120%;
                a {
                    padding-left: 0;
                    padding-right: 0;
                    padding-bottom: 0.5em;
                    border: none;
                }
                margin-right: 35px;
                &:last-child {
                    margin-right: 0;
                }
            }
            li.active {
                border-bottom: 3px solid @capColorLighter;
                font-weight: bolder;
            }
            li, a {
                background: none;
            }
        }
        .table-sceleted {
            tr {
                td {
                    border-right: 1px solid #eaebf4 !important;
                    padding-top: 1.2em;
                    padding-bottom: 1.2em;
                    padding-left: 20px;
                    &:last-child {
                        border-right: none;
                    }
                }
            }
            &.vendor_list tbody tr td:nth-child(2) {
                text-align: left;
            }
        }
    }

     */
</style>

<style scoped lang="less">
    @import '../../less-mixins/legacy-config';

    .tabs.regular-page-tabs {
        .nav-tabs::v-deep {
            font-weight: 300;
            background: none;
            margin-bottom: 2em;
            border-bottom: 1px solid #b7b7c4;
            li {
                font-size: 120%;
                a {
                    padding-left: 0;
                    padding-right: 0;
                    padding-bottom: 0.5em;
                    border: none;
                }
                margin-right: 35px;
                &:last-child {
                    margin-right: 0;
                }
            }
            li.active {
                border-bottom: 3px solid @capColorLighter;
                font-weight: 500;
            }
            li, a {
                background: none;
            }
        }

    }
</style>
